import { Component, Input } from '@angular/core';
import { CDN_BASE_URL } from 'src/constants/param-constants';

@Component({
  selector: 'brand-reviews',
  templateUrl: 'brand-reviews.html',
  styleUrls: ['brand-reviews.scss'],
})
export class BrandReviewsComponent {

  @Input() reviewsTitle: string = `<h2 class="reviews_titleContent">SUCCESS STORIES</h2>`;
  @Input() disclaimer: string = '*Individual results may vary';
  @Input() star: string = `${CDN_BASE_URL}/1starGreen.png`;
  @Input() reviews: any[] = [];

  Arr = Array;

  constructor() { }


}
